import React from 'react';
import PropTypes from 'prop-types';
import { BodyText, Button, EditIcon, HeadingText } from '@paypalcorp/pp-react';
import { changePayment } from './helpers';
import styles from '../Fastlane.module.less';

export default function FlexiblePaymentSection({
  activeSection,
  paymentToken,
  profile,
  setPaymentToken
}) {
  return (
    <>
      <div className={styles.section_heading}>
        <HeadingText size="sm">Payment</HeadingText>
        {paymentToken && (
          <Button
            iconComponent={EditIcon}
            secondary
            className={styles.edit_button}
            onClick={() => changePayment(profile, setPaymentToken)}
            size="sm"
          >
            Edit
          </Button>
        )}
      </div>
      <section
        id="fastlane-payment-sdk-section"
        style={{ display: activeSection === 3 ? 'block' : 'none' }}
      >
        <div id="card-component" />
        <div id="fastlane-payment-section">
          <BodyText>
            {paymentToken?.paymentSource?.card?.lastDigits
              ? `💳 •••• ${paymentToken.paymentSource.card.lastDigits}`
              : ''}
            <div id="payment-watermark" />
          </BodyText>
        </div>
      </section>
    </>
  );
}

FlexiblePaymentSection.propTypes = {
  activeSection: PropTypes.number.isRequired,
  paymentToken: PropTypes.string,
  profile: PropTypes.node.isRequired,
  setPaymentToken: PropTypes.func.isRequired
};

FlexiblePaymentSection.defaultProps = {
  paymentToken: null
};
